import { render, staticRenderFns } from "./HotelTeaser.vue?vue&type=template&id=7e8b97ab&lang=pug&"
import script from "./HotelTeaser.vue?vue&type=script&lang=js&"
export * from "./HotelTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports